import { useContext } from 'react';
import { telemetryCtx } from '../contexts/telemetry';

/**
 * Returns telemetry context value
 */
export const useTelemetry = () => useContext(telemetryCtx);
